module.exports = __webpack_public_path__ + "static/img/bystage_white_01.74cc22ff.svg";